<div style="overflow-y: hidden; height: 100%">
  <!-- Header -->
  <header class="mobile address">
    <div>
      <mat-icon svgIcon="ss-logo" class="logo-img" *ngIf="prevToggleValue.length == 1" routerLink="/dashboard-mobile"></mat-icon>
      <mat-icon (click)="back()" *ngIf="prevToggleValue.length > 1">arrow_left</mat-icon>
    </div>
    <div style="color: white">
      {{ headerTitle | translate }} {{ headerObject }}
    </div>
    <div class="burger-menu">
      <button ejs-speeddial id="speedDialMenu" openIconCss="e-icons e-menu" closeIconCss="e-icons e-close" position="TopRight" (created)="speedMenuCreated()" (clicked)="speedMenuClicked($event)" [items]="menuItems"></button>
    </div>
  </header>

  <!-- Adressen suchen -->
  <ng-container *ngIf="toggle === 'suchen'">
    <main class="mobile address search">
      <mat-toolbar class="top-block">
        <mat-toolbar-row class="mat-elevation-z1">
          <div style="display: flex; width: 100%">
            <mat-icon>search</mat-icon>
            <input matInput class="search-control" [(ngModel)]="searchField" (keyup)="applyFilter(searchField)" type="text" placeholder="Begriff eingeben" #input />
            <mat-icon (click)="clearInput()">close</mat-icon>
          </div>
          <mat-checkbox #cbOnlyActiveAddresses class="cbInaktiv-margin" (change)="setActive()" [checked]="onlyActive">
            {{ "MAIN_APP_ADRESSES.aktive" | translate }}
          </mat-checkbox>
        </mat-toolbar-row>
      </mat-toolbar>

      <mat-list role="list" class="list">
        <ng-container *ngFor="let item of filteredAdresseList">
          <mat-list-item role="listitem" class="list-item" (click)="highlight(item)" [ngClass]="{ highlight: selectedAdressID == item.adressID }">
            <div class="contentWrapper">
              <div class="userDataContainer">
                <div>
                  <b>{{ item.lastName }} {{ item.firstName }}</b>
                </div>
                <div>{{ item.street1 }} {{ item.adressNo }}</div>
                <div>{{ item.zip }} {{ item.city }}</div>
              </div>

              <div class="buttonConrtainer">
                <button class="search-icon" mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_horiz</mat-icon>
                </button>
              </div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
        </ng-container>
      </mat-list>
    </main>

    <mat-menu #menu="matMenu" class>
      <button mat-menu-item (click)="toggleBtn('adressansicht')">
        {{ "MAIN_APP_ADRESSES.adressansicht" | translate }}
      </button>
      <button mat-menu-item (click)="neueNotiz()">Notizen</button>
      <a mat-menu-item target="_blank" href="http://maps.google.com/?q={{
          currAdresse.street1 + ', ' + currAdresse.zip
        }}">auf Karte anzeigen</a>
    </mat-menu>
  </ng-container>

  <!-- Ansprechpartner -->
  <ng-container *ngIf="toggle === 'ansprechpartner'">
    <main class="mobile address contact">
        <mat-card style="padding: 5px">
          <div style="display: flex;justify-content: space-between;padding: 0 16px;column-gap: 0.5em;">
            <div style="display: flex; align-items: center;">
              <mat-icon class="person swiss-icon">person</mat-icon>
            </div>
              <div style="flex: 1">
              <span> {{ currAdresse.lastName }} {{ currAdresse.firstName }}</span>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                <span>{{ currAdresse.zip }} {{ currAdresse.city }}</span>
                <span>&nbsp;</span>
                <span>{{ currAdresse.street1 }} {{ currAdresse.adressNo }}</span>
              </div>
              </div>
              <div style="display: flex; align-items: center;">
                <mat-icon class="swiss-icon" (click)="toggleBtn('suche')">search</mat-icon>
              </div>
              
          </div>
        </mat-card>
      <mat-divider></mat-divider>

      <div style="display: flex; flex-direction: column; row-gap: 0.5em; padding: 0.5em; justify-content: space-between;">
        <mat-accordion *ngFor="let ansprechPartner of dbAnsprechPartner">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ ansprechPartner.vorname }} {{ ansprechPartner.name }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="information-overview" style="padding: 0.5em">
              <div class="element" style="display: flex; column-gap: 1em">
                <mat-icon>phone</mat-icon>
                <a href="tel:{{ ansprechPartner.telefon }}">{{
                  ansprechPartner.telefon
                  }}</a>
              </div>
              <div class="element" style="display: flex; column-gap: 1em">
                <mat-icon>smartphone</mat-icon>
                <a href="tel:{{ ansprechPartner.natel }}">{{
                  ansprechPartner.natel
                  }}</a>
              </div>

              <div class="element" style="display: flex; column-gap: 1em">
                <mat-icon>mail</mat-icon>
                <a href="mailto:{{ ansprechPartner.email }}">{{
                  ansprechPartner.email
                  }}</a>
              </div>
              <div class="element" style="display: flex; column-gap: 1em">
                <mat-icon>language</mat-icon>

                <a target="_blank" href="{{!ansprechPartner.homepage.startsWith('https://')? 'https://': '' }}{{ ansprechPartner.homepage }}">{{ ansprechPartner.homepage }}</a>

              </div>
              <mat-divider style="margin: 0.5em 0"></mat-divider>
              <div class="element" style="display: flex; column-gap: 1em">
	              <mat-icon (click)="editAnsprechpartner(ansprechPartner)" (click)="toggleBtn('mutieren-ansprechpartner')">edit</mat-icon>
                <mat-icon (click)="delAnsprechpartner(ansprechPartner)">delete</mat-icon>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
	      
	      <button (click)="onNewPartner()" mat-stroked-button>{{ "MAIN_APP_ADRESSES.ansprechpartnerErfassen" | translate }}</button>
      </div> 
      
    </main>
  </ng-container>

  <!-- Mutieren - adresse -->
  <ng-container *ngIf="toggle === 'mutieren-adresse'">
    <main class="mobile address address-mutation">
      <div style="display: flex; gap: 10px; flex-direction: column;">
        <mat-card style="padding: 5px">
          <div style="display: flex; justify-content: space-between; padding: 0 16px; column-gap: 0.5em;">
            <div style="display: flex; align-items: center;">
              <mat-icon class="person swiss-icon">person</mat-icon>
            </div>
            <div style="flex: 1">
              <span> {{ currAdresse.lastName }} {{ currAdresse.firstName }}</span>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                <span>{{ currAdresse.zip }} {{ currAdresse.city }}</span>
                <span> </span>
                <span>{{ currAdresse.street1 }} {{ currAdresse.adressNo }}</span>
              </div>
            </div>
            <div style="display: flex; align-items: center;">
              <mat-icon class="swiss-icon" (click)="toggleBtn('suche')">search</mat-icon>
            </div>
          </div>
        </mat-card>


        <mat-accordion [multi]="false">
          <mat-expansion-panel [expanded]="expandStateAdresse === 0" (opened)="setExpandStateAdresse(0)" [disabled]="selectedAdressID === ''">
            <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight">
              <mat-panel-title>
                {{ "MAIN_APP_ADRESSES.ADRESSE" | translate }}
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="checkboxNrContainer">
              <mat-form-field style="width: 5em">
                <mat-label>Nr.</mat-label>
                <input matInput disabled [(ngModel)]="currAdresse.adressNo" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
  
              <mat-checkbox style="width: 60%" class="cbInaktiv-margin" [checked]="allCompleteInaktiv" [color]="taskInaktiv.color" [indeterminate]="someCompleteInaktiv()" (change)="setAllInaktiv($event.checked)" [disabled]="!rechtAdresseMutieren">
                {{ taskInaktiv.name }}
              </mat-checkbox>
            </div>
            <div class="row">
              <mat-form-field class="contentWidth">
                <mat-label>{{ "MAIN_APP_ADRESSES.name" | translate }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.lastName" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" required />
              </mat-form-field>
  
              <mat-form-field class="contentWidth">
                <mat-label>{{
                  "MAIN_APP_ADRESSES.vorname" | translate
                  }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.firstName" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
            </div>
  
            <div class="row">
              <mat-form-field class="contentWidth">
                <mat-label>{{ "MAIN_APP_ADRESSES.titel" | translate }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.title" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
  
              <mat-form-field class="contentWidth">
                <mat-label>{{
                  "MAIN_APP_ADRESSES.zusatz" | translate
                  }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.companyDescription" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
            </div>
  
            <div class="row">
              <mat-form-field class="contentWidth">
                <mat-label>{{
                  "MAIN_APP_ADRESSES.strasse" | translate
                  }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.street1" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
  
              <mat-form-field class="contentWidth">
                <mat-label>{{ "MAIN_APP_ADRESSES.plz" | translate }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.zip" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" required />
              </mat-form-field>
            </div>
  
            <div class="row">
              <mat-form-field class="contentWidthOneElement">
                <mat-label>Ort</mat-label>
                <input matInput [(ngModel)]="currAdresse.city" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" required />
              </mat-form-field>
            </div>
  
            <div class="row">
              <mat-form-field class="contentWidth">
                <mat-label>{{
                  "MAIN_APP_ADRESSES.mobile" | translate
                  }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.phone03" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
  
              <mat-form-field class="contentWidth">
                <mat-label>{{
                  "MAIN_APP_ADRESSES.telefon" | translate
                  }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.phone01" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
            </div>
  
            <div class="row">
              <mat-form-field class="contentWidth">
                <mat-label>{{ "MAIN_APP_ADRESSES.email" | translate }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.email" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
  
              <mat-form-field class="contentWidth">
                <mat-label>{{
                  "MAIN_APP_ADRESSES.homepage" | translate
                  }}</mat-label>
                <input matInput [(ngModel)]="currAdresse.homepage" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
              </mat-form-field>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #expaAE [expanded]="expandStateAdressDetails === 0" (opened)="setExpandStateAdressDetails(0)" [disabled]="selectedAdressID === ''">
            <mat-expansion-panel-header [collapsedHeight]="expandPanelHeaderCollapsedHeight" [expandedHeight]="expandPanelHeaderExpandendHeight">
              <mat-panel-title>
                {{ "MAIN_APP_ADRESSES.ADRESSERWEITERUNG" | translate }}
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <app-dialog-layout>
              <div class="row">
                <mat-form-field class="contentWidth">
                  <mat-label>{{
                    "MAIN_APP_ADRESSES.anrede" | translate
                    }}</mat-label>
                  <input matInput [(ngModel)]="currAdresse.letterHead" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
  
                <mat-form-field class="contentWidth">
                  <mat-label>{{
                    "MAIN_APP_ADRESSES.briefanrede" | translate
                    }}</mat-label>
                  <input matInput [(ngModel)]="currAdresse.salutation" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
              </div>
  
              <div class="row">
                <mat-form-field class="contentWidth">
                  <mat-label>{{ "MAIN_APP_ADRESSES.strasse" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.street2" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
                <mat-form-field class="contentWidth">
                  <mat-label>{{
                    "MAIN_APP_ADRESSES.landKuerzel" | translate
                    }}</mat-label>
                  <input matInput [(ngModel)]="currAdresse.countryISOShort" (ngModelChange)="modelChangeFn($event, 'LandKuerzel')" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
              </div>
  
              <div class="row">
                <mat-form-field class="contentWidth">
                  <mat-label>{{
                    "MAIN_APP_ADRESSES.land" | translate
                    }}</mat-label>
                  <mat-select [(ngModel)]="currAdresse.country.isoShort" (ngModelChange)="modelChangeFn($event, 'Land')" [disabled]="!rechtAdresseMutieren">
                    <mat-option *ngFor="let land of laender" [value]="land.isoShort">
                      {{ land.isoNameNational }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
  
                <mat-form-field class="contentWidth">
                  <mat-label>{{
                    "MAIN_APP_ADRESSES.warnung" | translate
                    }}</mat-label>
                  <mat-select [(ngModel)]="currAdresse.adressStatus" (ngModelChange)="modelChangeFn($event)" [disabled]="!rechtAdresseMutieren">
                    <mat-option *ngFor="let adrState of adressStatus" [value]="adrState.id">
                      {{ adrState.description }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <h4 style="margin: 15px 0 0 0">
                {{ "MAIN_APP_ADRESSES.zusatzadresse" | translate }}
              </h4>
  
              <div class="checkboxNrContainer">
                <mat-checkbox class="cbErsteAdresszeile-margin" [checked]="allCompleteErsteAdresszeile" [color]="taskErsteAdresszeile.color" [indeterminate]="someCompleteErsteAdresszeile()" [disabled]="!rechtAdresseMutieren" (change)="setAllErsteAdresszeile($event.checked)" style="width: 100%">
                  {{ taskErsteAdresszeile.name }}
                </mat-checkbox>
              </div>
  
              <div class="row">
                <mat-form-field class="contentWidth">
                  <mat-label>{{ "MAIN_APP_ADRESSES.name" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.lastName2" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
  
                <mat-form-field class="contentWidth">
                  <mat-label>{{ "MAIN_APP_ADRESSES.vorname" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.firstName2" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
              </div>
  
              <div class="row">
                <mat-form-field class="contentWidth">
                  <mat-label>{{ "MAIN_APP_ADRESSES.titel" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.title2" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
  
                <mat-form-field class="contentWidth">
                  <mat-label>{{ "MAIN_APP_ADRESSES.anrede" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.letterHead2" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
              </div>
  
              <div class="row">
                <mat-form-field class="contentWidth">
                  <mat-label>{{ "MAIN_APP_ADRESSES.mobile" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.phone04" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
  
                <mat-form-field class="contentWidth">
                  <mat-label>{{ "MAIN_APP_ADRESSES.telefon" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.phone02" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field class="contentWidthOneElement">
                  <mat-label>{{ "MAIN_APP_ADRESSES.email" | translate }} 2</mat-label>
                  <input matInput [(ngModel)]="currAdresse.email2" (ngModelChange)="modelChangeFn($event)" [readonly]="!rechtAdresseMutieren" />
                </mat-form-field>
              </div>
            </app-dialog-layout>
          </mat-expansion-panel>
        </mat-accordion>

      </div>
        
      <mat-divider></mat-divider>

      
    </main>
  </ng-container>

  <!-- Mutieren - ansprechpartner -->
  <ng-container *ngIf="toggle === 'mutieren-ansprechpartner'">
    <main class="mobile address contact-mutation">
      <div class="mutation-fix">
        <div>
          <mat-form-field>
            <mat-label>Nr.</mat-label>
            <input matInput disabled [(ngModel)]="currAnsprechPartner.adressNo" />
          </mat-form-field>
          <mat-checkbox class="cbErsteAdresszeile-margin" [checked]="allCompleteHauptAnsprechpartner" [color]="taskHauptAnsprechpartner.color" [indeterminate]="someCompleteHauptAnsprechpartner()" (change)="setAllHauptAnsprechpartner($event.checked)">
            {{ taskHauptAnsprechpartner.name }}
          </mat-checkbox>
          <mat-checkbox class="cbErsteAdresszeile-margin" [checked]="allCompletePersKontakt" [color]="taskPersKontakt.color" [indeterminate]="someCompletePersKontakt()" (change)="setAllPersKontakt($event.checked)">
            {{ taskPersKontakt.name }}
          </mat-checkbox>
        </div>

        <div>
          <mat-form-field>
            <mat-label>{{ "MAIN_APP_ADRESSES.name" | translate }}</mat-label>
	          <input (keyup)="onNameChange($event)" (ngModelChange)="modelChangeAPFn()" [(ngModel)]="currAnsprechPartner.lastName" matInput required/>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ "MAIN_APP_ADRESSES.vorname" | translate }}</mat-label>
	          <input (keyup)="onVornameChange($event)" (ngModelChange)="modelChangeAPFn()" [(ngModel)]="currAnsprechPartner.firstName" matInput/>
          </mat-form-field>
        </div>

        <mat-form-field class="no-padding">
          <mat-label>{{ "MAIN_APP_ADRESSES.anrede" | translate }}</mat-label>
          <mat-select [(ngModel)]="currAnsprechPartner.anrede" required>
            <mat-option *ngFor="let opt of anreden" [value]="opt.anrede" (click)="onAnredeChange(opt)">
              {{opt.anrede}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="no-padding">
          <mat-label>{{ "MAIN_APP_ADRESSES.briefanrede" | translate }}</mat-label>
          <mat-select [(ngModel)]="currAnsprechPartner.briefanrede" required>
            <mat-option *ngFor="let opt of briefAnredenAbgefuellt" [value]="opt.briefanrede" (click)="onBriefanredeChange(opt)">
              {{opt.briefanrede}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="no-padding">
          <mat-label>{{ "MAIN_APP_ADRESSES.zuHanden" | translate }}</mat-label>
          <mat-select [(ngModel)]="currAnsprechPartner.zuhanden" required>
            <mat-option *ngFor="let opt of zuHandenAbgefuellt" [value]="opt" (click)="onZuHandenChange(opt)">
              {{opt}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ "MAIN_APP_ADRESSES.info" | translate }}</mat-label>
	        <input (ngModelChange)="modelChangeAPFn()" [(ngModel)]="currAnsprechPartner.ansprechInfo" matInput/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "MAIN_APP_ADRESSES.mobile" | translate }}</mat-label>
	        <input (ngModelChange)="modelChangeAPFn()" [(ngModel)]="currAnsprechPartner.mobile" matInput/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "MAIN_APP_ADRESSES.telefon" | translate }}</mat-label>
	        <input (ngModelChange)="modelChangeAPFn()" [(ngModel)]="currAnsprechPartner.telefon" matInput/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "MAIN_APP_ADRESSES.email" | translate }}</mat-label>
	        <input (ngModelChange)="modelChangeAPFn()" [(ngModel)]="currAnsprechPartner.email" matInput/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ "MAIN_APP_ADRESSES.homepage" | translate }}</mat-label>
	        <input (ngModelChange)="modelChangeAPFn()" [(ngModel)]="currAnsprechPartner.homepage" matInput/>
        </mat-form-field>
      </div>
    </main>
  </ng-container>

  <!-- Teilen -->
  <ng-container *ngIf="toggle === 'teilen'">
    <main class="mobile address share">
        <mat-card style="padding: 5px;">
          <div style="display: flex; justify-content: space-between; padding: 0 16px; column-gap: 0.5em;">
            <div style="display: flex; align-items: center;">
              <mat-icon class="person swiss-icon">person</mat-icon>
            </div>
            <div style="flex: 1">
              <span> {{ currAdresse.lastName }} {{ currAdresse.firstName }}</span>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                <span>{{ currAdresse.zip }} {{ currAdresse.city }}</span>
                <span> </span>
                <span>{{ currAdresse.street1 }} {{ currAdresse.adressNo }}</span>
            </div>
          </div>
          <div style="display: flex; align-items: center;">
            <mat-icon class="swiss-icon" (click)="toggleBtn('suche')">search</mat-icon>
          </div>
            
         </div>
        </mat-card>
      <mat-divider></mat-divider>

      <div class="information-overview" style="padding: 0.5em">
        <div class="element" style="display: flex; column-gap: 1em">
          <mat-icon>phone</mat-icon>
          <a href="tel:{{ currAdresse.phone01 }}">{{ currAdresse.phone01 }}</a>
        </div>
        <div class="element" style="display: flex; column-gap: 1em">
          <mat-icon>smartphone</mat-icon>
          <a href="tel:{{ currAdresse.phone02 }}">{{ currAdresse.phone02 }}</a>
        </div>
        <div class="element" style="display: flex; column-gap: 1em">
          <mat-icon>smartphone</mat-icon>
          <a href="tel:{{ currAdresse.phone03 }}">{{ currAdresse.phone03 }}</a>
        </div>
        <div class="element" style="display: flex; column-gap: 1em">
          <mat-icon>mail</mat-icon>
          <a href="mailto:{{ currAdresse.email }}">{{ currAdresse.email }}</a>
        </div>
        <div class="element" style="display: flex; column-gap: 1em">
          <mat-icon>language</mat-icon>
          <a target="_blank" href="{{!currAdresse.homepage.startsWith('https://')? 'https://': '' }}{{ currAdresse.homepage }}" *ngIf="currAdresse.homepage">{{ currAdresse.homepage }}</a>
        </div>
      </div>
    </main>
  </ng-container>

  <!-- Objekt adressen -->
  <ng-container *ngIf="toggle === 'objektliste'">
    <main class="mobile address object-list">
      <div class="mat-elevation-z8" *ngIf="hasObjekts == 1">
        <table mat-table [dataSource]="dataSourceObjektListe">
          <ng-container matColumnDef="objectNo">
            <th mat-header-cell *matHeaderCellDef>Obj.-Nr.</th>
            <td mat-cell *matCellDef="let element">
              {{ element.objectNumber }}
            </td>
          </ng-container>

          <ng-container matColumnDef="typeDesc">
            <th mat-header-cell *matHeaderCellDef>Typ</th>
            <td mat-cell *matCellDef="let element">
              {{ element.typeDescription }}
            </td>
          </ng-container>

          <ng-container matColumnDef="desc">
            <th mat-header-cell *matHeaderCellDef>Bezeichnung</th>
            <td mat-cell *matCellDef="let element">
              {{ element.description }}
            </td>
          </ng-container>

          <ng-container matColumnDef="objekt">
            <th mat-header-cell *matHeaderCellDef>Objekt</th>
            <td mat-cell *matCellDef="let element">{{ element.note4 }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedObjektColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedObjektColumns" [ngClass]="{ highlight: selectedObjektID == row.objectID }" (click)="openObjekt(row)"></tr>
        </table>
      </div>
    </main>
  </ng-container>

  <!-- Adressansicht  -->
  <ng-container *ngIf="toggle === 'adressansicht'">
    <main class="mobile address view">
        <mat-card style="padding: 5px;">
          <div style="display: flex; justify-content: space-between; padding: 0 16px; column-gap: 0.5em;">
            <div style="display: flex; align-items: center;">
              <mat-icon class="person swiss-icon">person</mat-icon>
            </div>
            <div style="flex: 1">
              <span> {{ currAdresse.lastName }} {{ currAdresse.firstName }}</span>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                <span>{{ currAdresse.zip }} {{ currAdresse.city }}</span>
                <span> </span>
                <span>{{ currAdresse.street1 }} {{ currAdresse.adressNo }}</span>
              </div>
            </div>
            <div style="display: flex; align-items: center;">
              <mat-icon class="swiss-icon" (click)="toggleBtn('suche')">search</mat-icon>
            </div>
          </div>
        </mat-card>
        
      <mat-divider></mat-divider>

        <div class="information-overview" style="padding: 0.5em">
          <div class="element" style="display: flex; column-gap: 1em">
            <mat-icon>phone</mat-icon>
            <a href="tel:{{ currAdresse.phone01 }}"> {{ currAdresse.phone01 }}</a>
          </div>
          <div class="element" style="display: flex; column-gap: 1em">
            <mat-icon>smartphone</mat-icon>
            <a href="tel:{{ currAdresse.phone02 }}"> {{ currAdresse.phone02 }}</a>
          </div>
  
          <div class="element" style="display: flex; column-gap: 1em">
            <mat-icon>smartphone</mat-icon>
            <a href="tel:{{ currAdresse.phone03 }}">{{ currAdresse.phone03 }}</a>
          </div>
  
          <div class="element" style="display: flex; column-gap: 1em">
            <mat-icon>mail</mat-icon>
            <a href="mailto:{{ currAdresse.email }}">{{ currAdresse.email }}</a>
          </div>
  
          <div class="element" style="display: flex; column-gap: 1em">
            <mat-icon>mail</mat-icon>
            <a href="mailto:{{ currAdresse.email2 }}">{{ currAdresse.email2 }}</a>
          </div>
          <div class="element" style="display: flex; column-gap: 1em">
            <mat-icon>language</mat-icon>
            <a target="_blank" href="{{!currAdresse.homepage.startsWith('https://')? 'https://': '' }}{{ currAdresse.homepage }}" *ngIf="currAdresse.homepage">{{ currAdresse.homepage }}</a>
          </div>
  
          <button mat-stroked-button (click)="delAddress()">Adresse löschen</button>
        </div>
      
    </main>
  </ng-container>

  <footer class="mobile address">
    <mat-icon (click)="toggleBtn('ansprechpartner')"> person-search </mat-icon>
    <mat-icon (click)="toggleBtn('teilen')"> share </mat-icon>
    <mat-icon (click)="toggleBtn('mutieren-adresse')"> edit </mat-icon>
    <mat-icon (click)="toggleBtn('objektliste')"> home </mat-icon>
  </footer>
</div>
